const BASIC = "/v1/ext";

export const GET_WEBROTATE_API = `${BASIC}/webrotate360`;
